import React from "react";

import {styled} from "@mui/material/styles";

import {ReactComponent as Shop} from "assets/img/shop-linear.svg";
const StyledSvg = styled(Shop)({
    width: '20px',
    height: '20px',
    'path': {
        stroke: 'currentColor'
    }
});

export default function RetailersIcon(props) {
    return <StyledSvg {...props} />;
}
